/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TwilioMessagesBody model module.
 * @module model/TwilioMessagesBody
 * @version v0.3
 */
export default class TwilioMessagesBody {
  /**
   * Constructs a new <code>TwilioMessagesBody</code>.
   * @alias module:model/TwilioMessagesBody
   * @class
   * @param message {String} 
   */
  constructor(message) {
    this.message = message;
  }

  /**
   * Constructs a <code>TwilioMessagesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TwilioMessagesBody} obj Optional instance to populate.
   * @return {module:model/TwilioMessagesBody} The populated <code>TwilioMessagesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TwilioMessagesBody();
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} message
 */
TwilioMessagesBody.prototype.message = undefined;

